import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";

export default function SLACompliance() {
  const [range, setRange] = useState("Monthly");
  const [open, setOpen] = useState(false);

  const dataSets = {
    Today: 78,
    Weekly: 75,
    Monthly: 80.5,
  };

  const value = dataSets[range];

  const radius = 70;
  const circumference = 2 * Math.PI * radius;
  const progress = (value / 100) * circumference;

  return (
    <Card className="h-100" style={styles.card}>
      <Card.Body>

        {/* HEADER */}
        <div style={styles.header}>
          <h5 style={styles.title}>SLA Compliance</h5>

          {/* DROPDOWN */}
          <div style={{ position: "relative" }}>
            <button
              style={styles.dropdownBtn}
              onClick={() => setOpen(!open)}
            >
              <FiCalendar size={14} /> {range}
            </button>

            {open && (
              <div style={styles.dropdown}>
                {["Today", "Weekly", "Monthly"].map((item) => (
                  <div
                    key={item}
                    style={styles.dropdownItem}
                    onClick={() => {
                      setRange(item);
                      setOpen(false);
                    }}
                  >
                    {item}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* GRAPH */}
        <div style={styles.chartWrap}>
          <svg viewBox="0 0 200 200" style={{ width: 240 }}>

            {/* BACK TRACK */}
            <circle
              cx="100"
              cy="100"
              r={radius}
              fill="none"
              stroke="#e5e7eb"
              strokeWidth="14"
            />

            {/* PROGRESS */}
            <circle
              cx="100"
              cy="100"
              r={radius}
              fill="none"
              stroke="#9a4f2b"
              strokeWidth="14"
              strokeDasharray={circumference}
              strokeDashoffset={circumference - progress}
              strokeLinecap="round"
              transform="rotate(-90 100 100)"
            />

            {/* CENTER TEXT */}
            <text
              x="100"
              y="105"
              textAnchor="middle"
              fontSize="20"
              fontWeight="600"
              fill="#1f2937"
            >
              {value}%
            </text>

            {/* CLOCK TICKS */}
            {[0, 60, 120, 180, 240, 300].map((angle, i) => {
              const x1 = 100 + Math.cos((angle * Math.PI) / 180) * 50;
              const y1 = 100 + Math.sin((angle * Math.PI) / 180) * 50;
              const x2 = 100 + Math.cos((angle * Math.PI) / 180) * 60;
              const y2 = 100 + Math.sin((angle * Math.PI) / 180) * 60;

              return (
                <line
                  key={i}
                  x1={x1}
                  y1={y1}
                  x2={x2}
                  y2={y2}
                  stroke="#6b7280"
                  strokeWidth="2"
                />
              );
            })}
          </svg>
        </div>

        {/* LIST */}
        <div style={styles.list}>

          <RowItem label="First Response SLA" value="96.2%" color="#22c55e" />
          <RowItem label="Resolution SLA" value="92.8%" color="#22c55e" />
          <RowItem label="Escalation SLA" value="89.5%" color="#ef4444" />

        </div>

      </Card.Body>
    </Card>
  );
}

/* ROW COMPONENT */
const RowItem = ({ label, value, color }) => (
  <div style={styles.row}>
    <div style={styles.left}>
      <span style={{ ...styles.bar, background: color }} />
      {label}
    </div>

    <div style={{ ...styles.badge, background: color }}>
      {value}
    </div>
  </div>
);

/* STYLES */
const styles = {
  card: {
    borderRadius: 5,
      border: "2px solid #e5e7eb",

  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 15,
  },

  title: {
    fontWeight: 600,
  },

  dropdownBtn: {
    border: "1px solid #e5e7eb",
    padding: "6px 10px",
    borderRadius: 8,
    background: "#fff",
    display: "flex",
    alignItems: "center",
    gap: 5,
    fontSize: 13,
  },

  dropdown: {
    position: "absolute",
    top: 40,
    right: 0,
    background: "#fff",
    borderRadius: 12,
    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
    overflow: "hidden",
  },

  dropdownItem: {
    padding: "10px 16px",
    cursor: "pointer",
  },

  chartWrap: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 10,
  },

  list: {
    marginTop: 10,
  },

  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
  },

  left: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    color: "#374151",
  },

  bar: {
    width: 3,
    height: 16,
    borderRadius: 2,
  },

  badge: {
    color: "#fff",
    padding: "4px 10px",
    borderRadius: 20,
    fontSize: 12,
  },
};